export const getSealCertificate = (state) => state.seal_certificate
